import {
  GetPlattformMessagesParams,
  MessagePrimaryChannelStatus,
  MessageSortByParam,
  MessageType,
  ValidationStatus,
} from "@bvhi/backend-api/apis";

export const defaultMessagesFilter: GetPlattformMessagesParams = {
  page: 0,
  size: 25,
  sort: [MessageSortByParam.CREATED_AT_DESC],
  messageType: [
    MessageType.DESPATCH_ADVICE,
    MessageType.INVOICE,
    MessageType.ORDER,
    MessageType.OTHER,
    MessageType.TEST,
    MessageType.TRANSPORT_ACKNOWLEDGEMENT,
  ],
  messagePrimaryChannelStatus: [
    MessagePrimaryChannelStatus.ACTIVE,
    MessagePrimaryChannelStatus.DELIVERED,
    MessagePrimaryChannelStatus.FAILED,
    MessagePrimaryChannelStatus.STALLED,
  ],
  messageValidationStatus: [ValidationStatus.INVALID, ValidationStatus.VALID, ValidationStatus.OPEN],
};
